import ShippmentDetails from '../../PackingListFormComponents/ShippmentDetails';
import TransportDetails from '../../PackingListFormComponents/TransportDetails';
import PortDetails from '../../PackingListFormComponents/PortDetails';
import { SuitUIButton } from '../../../../../SuitUIButton';
import Parkinglistfield from '../../../../../../pages/dashboard/tradedocuments/parkinglist/parkinglistfield/parkinglistfield';
import { PackingListInterface } from '../../../../../../pages/dashboard/tradedocuments/tradeDocumentTypes/parkinglistTypes';

const StepTwo = ({
    updateField,
    payload,

    countries,
    isCountriesLoading,
    setShowAddPartner,
    errors,
    quoteFields,
    updateQuoteField,
    removeQuoteField,
    addQuoteField
}: PackingListInterface) => {
    return (
        <div className='w-full flex flex-col gap-4'>
            <ShippmentDetails
                {...{
                    errors,
                    payload,
                    countries,
                    updateField,
                    isCountriesLoading,
                    setShowAddPartner
                }}
            />

            <TransportDetails
                {...{
                    errors,
                    payload,
                    countries,
                    updateField,
                    isCountriesLoading,
                    setShowAddPartner
                }}
            />

            <PortDetails
                {...{
                    errors,
                    payload,
                    updateField,
                    setShowAddPartner
                }}
            />

            {quoteFields.map((item, index) => (
                <Parkinglistfield
                    key={item.id}
                    index={index}
                    id={item.id}
                    updateQuoteField={updateQuoteField}
                    kindOfPackage={item.kindOfPackage}
                    qtyOfPackage={item.qtyOfPackage}
                    weightOfPackageKG={item.weightOfPackageKG}
                    grossWeightOfPackageKG={item.grossWeightOfPackageKG}
                    measurementOfPackage={item.measurementOfPackage}
                    qty={item.qty}
                    removeQuoteField={removeQuoteField}
                    item={item}
                />
            ))}

            <SuitUIButton
                text='Add commodity'
                onClick={addQuoteField}
                invert
                fullWidth
                style='px-[0.92rem] border border-gray300 text-steelBlue font-medium text-sm leading-[20px] lg:border-none lg:text-appcolorprimary'
            />
        </div>
    );
};

export default StepTwo;
